
export function getCO2MehrkostenBase() {

    const arr = [
        {
          key: 'ottokraftstoff',
          name: 'Ottokraftstoff',
        },
        {
          key: 'diesel',
          name: 'Diesel',
        },
        {
          key: 'heizoel_leicht',
          name: 'Heizöl (leicht)',
        },
        {
          key: 'fluessiggas',
          name: 'Flüssiggas',
        },
        {
          key: 'erdgas',
          name: 'Erdgas',
        },
        {
          key: 'biomasse_holz',
          name: 'Biomasse Holz',
        },
        {
          key: 'hackschnitzel',
          name: 'Hackschnitzel',
        },
        {
          key: 'holzpellets',
          name: 'Holzpellets',
        },
        {
          key: 'fernwaerme_mix',
          name: 'Fernwärme MIX',
        },
        {
          key: 'strom_mix',
          name: 'Strom-Mix',
        }
      ];
      return arr;
}